<template>
  <div class="input-wrapper">
    <Label
      v-if="props.label"
      :for="props.for"
      :label="props.label"
      :sub-label="props.subLabel"
      :helper-text="props.helperText"
      :required="props.required"
    >
      <template #label-hint>
        <slot name="label-hint" />
      </template>
    </Label>
    <div>
      <slot></slot>
      <div
        v-if="props.error"
        :id="`${props.for}-error`"
        class="d-flex align-items-end text-danger mt-2"
      >
        <span class="material-symbols-outlined me-1">warning</span>
        {{ props.error }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import Label, { type LabelProps } from '../Label/Label.vue';

type InputWrapperProps = Omit<LabelProps, 'label'> & {
  label?: string; // Label is optional here but required for the Label component
  error?: string;
};

const props = defineProps<InputWrapperProps>();
</script>
<style lang="scss" scoped>
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
